import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const fromCamelToKebab = (any) => fromAnyToTrimmed(any).replace(/[A-Z]+(?![a-z])|[A-Z]/g, (matched, captured) => (captured ? '-' : '') + matched.toLowerCase());

export default fromCamelToKebab;
